import React from 'react';
import ResetPassword from './ResetPassword';

const ResetPasswordContainer = () => {
  return <ResetPassword />;
};

export default ResetPasswordContainer;
